import { PortfolioHomeRoot } from './styles';
import { useTranslation } from 'react-i18next';
import CarouselImageWithDots from '@composites/CarouselImageWithDots';
import LogoGalery from '@composites/LogoGalery';
import TextSection from '@composites/TextSection';
import Multitouchpoint from '@composites/Multitouchpoint';

import clientImage1 from '@assets/images/clients/coca-cola.png';
import clientImage2 from '@assets/images/clients/paypal.png';
import clientImage3 from '@assets/images/clients/basf.png';
import clientImage4 from '@assets/images/clients/adobe.png';
import clientImage5 from '@assets/images/clients/airbus.png';
import clientImage6 from '@assets/images/clients/polestar.png';
import clientImage7 from '@assets/images/clients/merck.png';
import clientImage8 from '@assets/images/clients/otto.png';
import clientImage9 from '@assets/images/clients/nasa.png';
import clientImage10 from '@assets/images/clients/adidas.png';
import clientImage11 from '@assets/images/clients/google.png';
import clientImage12 from '@assets/images/clients/bombardier.png';
import clientImage13 from '@assets/images/clients/bmw.png';
import clientImage14 from '@assets/images/clients/ABInBev.png';
import clientImage15 from '@assets/images/clients/daimler.png';
import clientImage16 from '@assets/images/clients/zalando.png';
import clientImage17 from '@assets/images/clients/vattenfall.png';
import clientImage18 from '@assets/images/clients/goto.png';
import clientImage19 from '@assets/images/clients/deloitte.png';
import clientImage20 from '@assets/images/clients/fedex.png';
import clientImage21 from '@assets/images/clients/amazon.png';
import clientImage22 from '@assets/images/clients/henkel.png';
import clientImage23 from '@assets/images/clients/ariane-group.png';
import clientImage24 from '@assets/images/clients/personio.png';
import partnerImage1 from '@assets/images/partners/siemens.png';
import partnerImage2 from '@assets/images/partners/rohde_schwarz.png';
import partnerImage3 from '@assets/images/partners/eon.png';
import partnerImage4 from '@assets/images/partners/telekom.png';
import partnerImage5 from '@assets/images/partners/lufthansa_group.png';
import partnerImage6 from '@assets/images/partners/bayer.png';
import partnerImage7 from '@assets/images/partners/rwe.png';
import partnerImage8 from '@assets/images/partners/ergo.png';
import partnerImage9 from '@assets/images/partners/espirit.png';
import partnerImage10 from '@assets/images/partners/DeutscheTelekom_bp.png';
import partnerImage11 from '@assets/images/partners/samsung-bp.png';
import partnerImage12 from '@assets/images/partners/hpe_bp.png';
import partnerImage13 from '@assets/images/partners/CA_bp.png';
import partnerImage14 from '@assets/images/partners/Automic_bp.png';
import partnerImage15 from '@assets/images/partners/SAP_bp.png';
import partnerImage16 from '@assets/images/partners/huawei_bp.png';
import partnerImage17 from '@assets/images/partners/ey.png';
import partnerImage18 from '@assets/images/partners/nvidia.png';
import partnerImage19 from '@assets/images/partners/kpmg.png';
import partnerImage20 from '@assets/images/partners/IBM_bp.png';
import partnerImage21 from '@assets/images/partners/GEDigital_bp.png';
import partnerImage22 from '@assets/images/partners/ACC_bp.png';
import partnerImage23 from '@assets/images/partners/Microsoft_bp.png';
import partnerImage24 from '@assets/images/partners/vodafone_bp.png';
import OurConceptSection from './components/OurConceptSection';
import IconsSection from './components/IconsSection';
import { absoluteFilePath } from '@utils/fn';
import TextMiddleSection from '@composites/TextMiddleSection';
import { ImageAndTextSection } from '@composites/ImageAndTextSection';
import HeroSectionWithRotatedImage from '@composites/HeroSectionWithRotatedImage';
import { ROUTES } from '@constants/routes';
import { MetaTags } from '@components/MetaTags';

const clients = [
  {
    id: '1',
    name: 'Coca-cola',
    logo: clientImage1,
  },
  {
    id: '2',
    name: 'Paypall',
    logo: clientImage2,
  },
  {
    id: '3',
    name: 'BASF',
    logo: clientImage3,
  },
  {
    id: '4',
    name: 'Zalando',
    logo: clientImage4,
  },
  {
    id: '5',
    name: 'Airbus',
    logo: clientImage5,
  },
  {
    id: '6',
    name: 'Polestar',
    logo: clientImage6,
  },
  {
    id: '7',
    name: 'Merck',
    logo: clientImage7,
  },
  {
    id: '8',
    name: 'Otto',
    logo: clientImage8,
  },
  {
    id: '9',
    name: 'Nasa',
    logo: clientImage9,
  },
  {
    id: '10',
    name: 'Adidas',
    logo: clientImage10,
  },
  {
    id: '11',
    name: 'Google',
    logo: clientImage11,
  },
  {
    id: '12',
    name: 'Bombardier',
    logo: clientImage12,
  },
  {
    id: '13',
    name: 'BMW',
    logo: clientImage13,
  },
  {
    id: '14',
    name: 'ABInBev',
    logo: clientImage14,
  },
  {
    id: '15',
    name: 'Daimler',
    logo: clientImage15,
  },
  {
    id: '16',
    name: 'Otto',
    logo: clientImage16,
  },
  {
    id: '17',
    name: 'Vattenfall',
    logo: clientImage17,
  },
  {
    id: '18',
    name: 'goto',
    logo: clientImage18,
  },
  {
    id: '19',
    name: 'Deloitte',
    logo: clientImage19,
  },
  {
    id: '20',
    name: 'FedEx',
    logo: clientImage20,
  },
  {
    id: '21',
    name: 'Amazon',
    logo: clientImage21,
  },
  {
    id: '22',
    name: 'Henkel',
    logo: clientImage22,
  },
  {
    id: '23',
    name: 'Ariane Group',
    logo: clientImage23,
  },
  {
    id: '24',
    name: 'Personio',
    logo: clientImage24,
  },
];

const partners = [
  {
    id: '1',
    name: 'Siemens',
    logo: partnerImage1,
  },
  {
    id: '2',
    name: 'Rohde & Schwarz',
    logo: partnerImage2,
  },
  {
    id: '3',
    name: 'EON',
    logo: partnerImage3,
  },
  {
    id: '4',
    name: 'Telekom',
    logo: partnerImage4,
  },
  {
    id: '5',
    name: 'Lufthansa Group',
    logo: partnerImage5,
  },
  {
    id: '6',
    name: 'Bayer',
    logo: partnerImage6,
  },
  {
    id: '7',
    name: 'RWE',
    logo: partnerImage7,
  },
  {
    id: '8',
    name: 'Airbus',
    logo: partnerImage8,
  },
  {
    id: '9',
    name: 'Espirit',
    logo: partnerImage9,
  },
  {
    id: '10',
    name: 'Deutsche Telekom',
    logo: partnerImage10,
  },
  {
    id: '11',
    name: 'Samsung',
    logo: partnerImage11,
  },
  {
    id: '12',
    name: 'Hewlett Packard',
    logo: partnerImage12,
  },
  {
    id: '13',
    name: 'CA Technologies',
    logo: partnerImage13,
  },
  {
    id: '14',
    name: 'Automic Software',
    logo: partnerImage14,
  },
  {
    id: '15',
    name: 'SAP SE',
    logo: partnerImage15,
  },
  {
    id: '16',
    name: 'Huawei Technologies Co., Ltd.',
    logo: partnerImage16,
  },
  {
    id: '17',
    name: 'EY (Ernst & Young)',
    logo: partnerImage17,
  },
  {
    id: '18',
    name: 'NVIDIA Corporation',
    logo: partnerImage18,
  },
  {
    id: '19',
    name: 'KPMG International Limited',
    logo: partnerImage19,
  },
  {
    id: '20',
    name: 'Siemens AG',
    logo: partnerImage20,
  },
  {
    id: '21',
    name: 'GE Digital',
    logo: partnerImage21,
  },
  {
    id: '22',
    name: 'Accenture',
    logo: partnerImage22,
  },
  {
    id: '23',
    name: 'Microsoft',
    logo: partnerImage23,
  },
  {
    id: '24',
    name: 'Vodafone Group Plc',
    logo: partnerImage24,
  },
];

export const PortfolioHome = () => {
  const { t } = useTranslation();

  return (
    <>
      <MetaTags
        title="we.CONECT Global Leaders Group"
        description="we.CONECT Global Leaders Group"
        keywords="we.CONECT, event, portfolio"
        image={`${window.location.origin}/1fdb62e88471bd6a3207.svg`}
        url={window.location.href}
        twitterCardType="summary_large_image"
        type="website"
      />
      <PortfolioHomeRoot>
        <HeroSectionWithRotatedImage
          titleStart={t('home-hero-section-title-1')}
          titleBlue={t('home-hero-section-title-2')}
          titleEnd={t('home-hero-section-title-3')}
          buttonText={t('home-hero-section-button')}
          buttonURL={t(ROUTES.OUR_PORTFOLIOS)}
          backgroundVideoURL="https://media.we-conect.com/videos/weconect_headervideo_event_2545x776px_digital.mp4"
          videoOverlay
        />

        <IconsSection />
        <TextMiddleSection
          title={t('home-unique-section-title')}
          titleBlue={t('home-unique-section-title-span')}
          title2={t('home-unique-section-title-finish')}
          paragraphs={[
            t('home-unique-section-text-1'),
            t('home-unique-section-text-2'),
          ]}
          maxWidth="84rem"
        />
        <ImageAndTextSection
          orientation="right"
          sectionName="Live Event"
          highlightText={t('live-events-section-title')}
          titleText={t('live-events-section-subtitle')}
          paragraphs={[
            t('live-events-section-paragraph-1'),
            t('live-events-section-paragraph-2'),
          ]}
          imageURL={absoluteFilePath(`/images/website/live_event.jpg`)}
          buttonText={t('live-events-section-button')}
          buttonURL={`${t(ROUTES.OUR_PORTFOLIOS)}#${t(ROUTES.OUR_PORTFOLIOS_EVENTS)}`}
          maxContentWidth="54.8rem"
          maxImageHeight="71.3rem"
          maxImageWidth="94rem"
        />
        <ImageAndTextSection
          orientation="left"
          sectionName="B2B"
          highlightText={t('b2b-section-title')}
          titleText={t('b2b-section-title-effective')}
          titleText2={`${t('b2b-section-title-data-based')} ${t('b2b-section-title-and-exclusive')}`}
          paragraphs={[
            t('b2b-section-paragraph-1'),
            t('b2b-section-paragraph-2'),
          ]}
          imageURL={
            'https://media.we-conect.com/images/website/digital_event.png'
          }
          buttonText={t('b2b-section-button-text')}
          buttonURL={`${t(ROUTES.OUR_PORTFOLIOS)}#${t(ROUTES.OUR_PORTFOLIOS_DIGITAL_HUB)}`}
          maxContentWidth="54.8rem"
          maxImageHeight="71.3rem"
          maxImageWidth="94rem"
        />
        <OurConceptSection />
        <Multitouchpoint />
        <TextSection
          title={t('our-customers')}
          paragraphs={[
            t('our-customers-paragraph-1'),
            t('our-customers-paragraph-2'),
          ]}
        />
        <LogoGalery items={clients} />
        <CarouselImageWithDots
          items={[
            {
              id: '1',
              text: t('customer-testimonial-1'),
              image: clientImage1,
            },
            {
              id: '2',
              text: t('customer-testimonial-2'),
              image: clientImage2,
            },
            {
              id: '3',
              text: t('customer-testimonial-3'),
              image: clientImage3,
            },
            {
              id: '4',
              text: t('customer-testimonial-4'),
              image: clientImage4,
            },
            {
              id: '5',
              text: t('customer-testimonial-5'),
              image: clientImage5,
            },
            {
              id: '6',
              text: t('customer-testimonial-6'),
              image: clientImage6,
            },
            {
              id: '7',
              text: t('customer-testimonial-7'),
              image: clientImage7,
            },
            {
              id: '8',
              text: t('customer-testimonial-8'),
              image: clientImage8,
            },
          ]}
        />

        <TextSection
          title={t('our-partners')}
          paragraphs={[
            t('our-partners-paragraph-1'),
            t('our-partners-paragraph-2'),
          ]}
        />
        <LogoGalery items={partners} />
        <CarouselImageWithDots
          items={[
            {
              id: '1',
              text: t('partner-testimonial-1'),
              image: partnerImage1,
            },
            {
              id: '2',
              text: t('partner-testimonial-2'),
              image: partnerImage2,
            },
            {
              id: '3',
              text: t('partner-testimonial-3'),
              image: partnerImage3,
            },
            {
              id: '4',
              text: t('partner-testimonial-4'),
              image: partnerImage4,
            },
            {
              id: '5',
              text: t('partner-testimonial-5'),
              image: partnerImage5,
            },
            {
              id: '6',
              text: t('partner-testimonial-6'),
              image: partnerImage6,
            },
            {
              id: '7',
              text: t('partner-testimonial-7'),
              image: partnerImage7,
            },
            {
              id: '8',
              text: t('partner-testimonial-8'),
              image: partnerImage8,
            },
          ]}
        />
        <ImageAndTextSection
          orientation="right"
          sectionName="Teamwork"
          highlightText={t('team-work-section-title')}
          titleText={t('team-work-section-subtitle')}
          paragraphs={[
            t('team-work-section-paragraph-1'),
            t('team-work-section-paragraph-2'),
          ]}
          imageURL={
            'https://media.we-conect.com/images/website/home_teamwork.jpg'
          }
          buttonText={t('team-work-section-button')}
          buttonURL={t(ROUTES.OUR_TEAM_URL)}
          maxContentWidth="54.8rem"
          maxImageWidth="94rem"
        />
      </PortfolioHomeRoot>
    </>
  );
};

export default PortfolioHome;
